import { connect } from 'react-redux'
import UI from './UI'
import { SeeMore, SelectCategoryFromSlugAction } from 'components/Catalog/store'
import { decorateUrl } from 'components/common/UTMscript'
import { push } from 'connected-react-router'

const mapDispatchToProps = dispatch => ({
  selectCategoryFromSlug: slug => dispatch(SelectCategoryFromSlugAction(slug)),
  goToLink: link => dispatch(push(decorateUrl(link))),
  seeMore: () => dispatch(SeeMore())
})

const mapStateToProps = ({ catalog }) => ({
  selectedCategory: catalog.selectedCategory,
  allCoursesCategory: catalog.allCoursesCategory,
  courses: catalog.courses,
  loading: catalog.loadingCourses,
  count: catalog.count
})

export default connect(mapStateToProps, mapDispatchToProps)(UI)
